module.exports = __webpack_public_path__ + "img/lv.56acb99b.svg";